import { style } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'

// The account drawer shell — a right-docking panel that APPEARS with a quiet opacity fade
// (never a slide), so the live sparkline stays the only moving thing. A fixed head over a
// scrolling body. Migrated off editorial.css's .ed-panel-*; Admin no longer uses this (it is
// a full-width workspace now — see admin.css.ts), so only the slim account weight remains.
export const root = style({
  position: 'fixed',
  inset: 0,
  zIndex: vars.z.overlay,
  display: 'flex',
  justifyContent: 'flex-end',
  opacity: 0,
  pointerEvents: 'none',
  transition: `opacity ${vars.dur.med} ease`,
  selectors: { '&.is-open': { opacity: 1, pointerEvents: 'auto' } },
  '@media': { '(prefers-reduced-motion: reduce)': { transition: 'none' } },
})
export const scrim = style({ position: 'absolute', inset: 0, background: vars.color.scrim })

export const panel = style({
  position: 'relative',
  height: '100vh',
  marginLeft: 'auto',
  width: 'min(100%, 460px)',
  background: vars.color.paper,
  borderLeft: `1px solid ${vars.color.ink}`,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: vars.shadow.edgeLg,
  '@media': { 'screen and (max-width: 560px)': { width: '100%', borderLeft: 0 } },
})
export const head = style({
  flex: 'none',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: vars.space[3],
  padding: `${vars.space[6]} ${vars.space[6]} ${vars.space[3]}`,
  borderBottom: `1px solid ${vars.color.rule}`,
  background: vars.color.paper,
})
export const title = style({
  margin: 0,
  fontFamily: vars.font.serif,
  fontWeight: 500,
  fontSize: vars.fs['2xl'],
  lineHeight: vars.lh.tight,
  color: vars.color.ink,
})
export const body = style({
  flex: 1,
  overflowY: 'auto',
  padding: `${vars.space[2]} ${vars.space[6]} ${vars.space[8]}`,
})
